import React, { useState, useEffect } from "react";

import {
	Box,
	Button,
	Dialog,
	DialogTitle,
	Grid,
	IconButton,
	TextField,
	MenuItem,
	DialogActions,
	Typography,
	// FormControlLabel,
} from "@mui/material";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import { Close as CloseIcon } from "@mui/icons-material";
import { createAssociation, updateAssociation } from "../../redux/actions/campaign.actions";
import { useDispatch, useSelector } from "react-redux";
import { getAllClients } from "../../redux/actions/client.actions";
import ButtonOnly from "../../components/Comman/button-new/buttonNew";
import { FaPaperPlane, FaEdit } from "react-icons/fa";
import { toast } from "react-toastify";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
	"& .MuiDialogContent-root": { padding: theme.spacing(2) },
	"& .MuiDialogActions-root": { padding: theme.spacing(1) },
	"& .MuiPaper-root": {
		width: '40%', // Ensure the dialog takes full width
		maxWidth: 'none', // Remove the default max width
	},
}));

function BootstrapDialogTitle(props) {
	const { children, onClose, ...other } = props;

	return (
		<DialogTitle sx={{ m: 0, p: 2 }} {...other}>
			{children}
			{onClose ? (
				<IconButton
					aria-label='close'
					onClick={onClose}
					sx={{
						position: "absolute",
						right: 8,
						top: 8,
						color: (theme) => theme.palette.grey[500],
					}}>
					<CloseIcon color="error" />
				</IconButton>
			) : null}
		</DialogTitle>
	);
}

BootstrapDialogTitle.propTypes = {
	children: PropTypes.node,
	onClose: PropTypes.func.isRequired,
};
const AssignCampaign = (props) => {
	const { clients } = useSelector((state) => state.clientReducer);

	const dispatch = useDispatch();

	const { openModal, handleModal, campaigns, isEdit, campaigndata } = props;

	const [clientCamp, setClientCamp] = useState({
		client_id: "",
		campaign_id: "",
		name: "",
		campaign_url: "",
		title: "",
		sub_title: "",
		prefilled: "",
		authMethod: ""
	});


	const [clientUpdate, setClientUpdate] = useState({
		client_id: "",
		prefilled: campaigndata?.prefilled,
		authMethod: campaigndata?.authMethod,
		title: campaigndata?.title,
		sub_title: campaigndata?.sub_title,
		campaign_url: campaigndata?.campaign_url,
	});


	useEffect(() => {
		dispatch(getAllClients());
	}, []);

	const handleInputChange = async (e) => {
		const { name, value } = e.target;
		if (name === "campaign_url") {
			setClientCamp({
				...clientCamp,
				[name]: value
			});
		}
		else {
			setClientCamp({ ...clientCamp, [name]: value });
		}
	};
	const handleInputUpdate = async (e) => {
		const { name, value } = e.target;
		if (name === "campaign_url") {
			setClientUpdate({
				...clientUpdate,
				[name]: value
			});
		}
		else {
			setClientUpdate({ ...clientUpdate, [name]: value });
		}
	};
	const handleInputChangeUpdate = (e) => {
		const { name, value } = e.target;
		setClientUpdate(prevState => ({
			...prevState,
			[name]: value
		}));
	};

	const handleInputChange1 = async (e, option, method) => {
		const { name, value } = e.target;
		const selectedData = await campaigns.find((e) => e.title === option.props.children)
		setClientCamp({
			...clientCamp,
			["name"]: option.props.children,
			["campaign_id"]: value,
			["campaign_url"]: selectedData.url
		});


	};
	const handleInputChange2 = async (e, option) => {
		let { name, value } = e.target;
		if (name === "prefilled") {
			value = value === "true" ? true : false;
		} else {
			value = value
		}
		if (isEdit === false) {
			setClientCamp({
				...clientCamp,
				[name]: value
			});
		} else {
			setClientUpdate({
				...clientUpdate,
				[name]: value
			});
		}
	};


	const handleClose = () => {
		handleModal(false);
	};
	const [error, setError] = useState(false)


	const handleSubmit = async (e) => {
		e.preventDefault();

		if (isEdit === false) {

			if (!clientCamp?.authMethod && !clientCamp?.campaign_id && !clientCamp?.client_id && !clientCamp?.clientCamp) return toast.error("Please Fill All The Input Field");
			dispatch(createAssociation(clientCamp));
		} else {

			let clientId = clientUpdate?.client_id?.client_id;
			if (!clientId) return setError(true);

			let updateClient = {
				client_id: clientId,
				prefilled: clientUpdate.prefilled,
				authMethod: clientUpdate.authMethod,
				title: clientUpdate.title,
				sub_title: clientUpdate.sub_title,
				campaign_url: clientUpdate?.campaign_url
			}
			let id = campaigndata?.coc;
			dispatch(updateAssociation(updateClient, id))
		}
		handleClose();
	};

	return (
		<BootstrapDialog
			onClose={handleClose}
			aria-labelledby='customized-dialog-title'
			open={openModal}
		>
			<BootstrapDialogTitle id='customized-dialog-title' onClose={handleClose} sx={{ textAlign: "center", background: "rgba(0, 165, 162, 0.7)", color: "white" }}>
				{isEdit === true ? `Update Client : ` : `Assign campaign`}
				{
					isEdit === true && <span className="text-warning">
						{campaigndata?.client_name}
					</span>
				}
			</BootstrapDialogTitle>
			<hr className="mt-0" />
			<form onSubmit={handleSubmit}>
				<Box
					sx={{
						"& .MuiTextField-root": { mx: 4, my: 2, width: "80%" },
					}}
				>
					<Grid container direction='row'>
						<Grid item xs={6}>
							<TextField
								required
								id='client_id'
								name='client_id'
								select
								label='Client'
								placeholder='Select Client'
								value={isEdit === false ? clientCamp.client_id : clientUpdate?.client_id}
								disabled={false}
								onChange={isEdit === false ? handleInputChange : handleInputChangeUpdate}>
								{clients.map((option) => (
									<MenuItem key={option.client_id} value={isEdit === false ? option.client_id : option}>
										{option.name}
									</MenuItem>
								))}
							</TextField>
							{error && <div className="text-danger" style={{ marginLeft: "2.4rem", fontSize: "15px" }}>Please Fill client Field..</div>}
						</Grid>

						{isEdit === false &&
							<>
								<Grid item xs={6}>
									<TextField
										required
										id='campaign_id'
										name="campaign"
										select
										label='Campaign'
										placeholder='Select associated campaign'
										value={clientCamp.campaign_id}
										disabled={false}
										onChange={handleInputChange1}>
										{campaigns.map((option) => (
											<MenuItem

												key={option.id}
												value={option.id}
												onClick={(e) => handleInputChange1(e, option)}
											>
												{option.title}
											</MenuItem>
										))}
									</TextField>
								</Grid>
							</>
						}

						<Grid item xs={6}>
							<TextField
								required
								id='prefilled'
								name="prefilled"
								select
								label='Prefelleds'
								placeholder='Select your prefilleds'
								value={isEdit === false ? clientCamp.prefilled : clientUpdate?.prefilled}
								disabled={false}
								onChange={handleInputChange2}
							>
								<MenuItem value="true">True</MenuItem>
								<MenuItem value="false">False</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={6}>
							<TextField
								required
								id='authMethod'
								name="authMethod"
								select
								label='Auth Methods'
								placeholder='Select Your Auth Method'
								value={isEdit === false ? clientCamp.authMethod : clientUpdate?.authMethod}
								disabled={false}
								onChange={handleInputChange2}
							>
								<MenuItem value="promo">Promo</MenuItem>
								<MenuItem value="bin">Bin</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={6}>
							<TextField
								required
								id='campaign_url'
								name='campaign_url'
								label='Campaign Url'
								placeholder='Insert campaign url'
								value={isEdit === false ? clientCamp.campaign_url : clientUpdate?.campaign_url}
								disabled={false}
								onChange={isEdit === false ? handleInputChange : handleInputUpdate}>
							</TextField>
						</Grid>
						<Grid item xs={6}>
							<TextField
								id='title'
								name='title'
								label='Title'
								placeholder='Insert Title'
								value={isEdit === false ? clientCamp.title : clientUpdate?.title}
								disabled={false}
								onChange={isEdit === false ? handleInputChange : handleInputUpdate}>
							</TextField>
						</Grid>
						<Grid item xs={6}>
							<TextField
								id='sub_title'
								name='sub_title'
								label='Sub-Title'
								placeholder='Insert Sub Title'
								value={isEdit === false ? clientCamp.sub_title : clientUpdate?.sub_title}
								disabled={false}
								onChange={isEdit === false ? handleInputChange : handleInputUpdate}>
							</TextField>
						</Grid>
					</Grid>
					<hr />
					<DialogActions className="mb-2 justify-content-center">
						<ButtonOnly
							buttonLabel={isEdit ? "Update" : "Submit"}
							buttonIcon={isEdit ? <FaEdit /> : <FaPaperPlane />}
							buttonClick={handleSubmit}
						/>
					</DialogActions>
				</Box>
			</form>
		</BootstrapDialog>
	);
};

export default AssignCampaign;
